import React from "react";
import { Typography, Card, Space, Divider } from "antd";
import { useLanguage } from "../i18n/LanguageContext";

const { Title, Paragraph, Text } = Typography;

const TermsPage: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div style={{ padding: "24px" }}>
      <Card>
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          <Title level={2}>{t("terms.title")}</Title>
          <Paragraph>{t("terms.welcome")}</Paragraph>

          <div>
            <Title level={3}>{t("terms.acceptance.title")}</Title>
            <Paragraph>{t("terms.acceptance.content")}</Paragraph>
          </div>

          <div>
            <Title level={3}>{t("terms.license.title")}</Title>
            <Title level={4}>{t("terms.license.permission.title")}</Title>
            <Paragraph>{t("terms.license.permission.content")}</Paragraph>
            <Title level={4}>{t("terms.license.restrictions.title")}</Title>
            <Paragraph>{t("terms.license.restrictions.content")}</Paragraph>
            <Paragraph style={{ whiteSpace: "pre-line" }}>
              {t("terms.license.restrictions.list")}
            </Paragraph>
          </div>

          <div>
            <Title level={3}>{t("terms.content.title")}</Title>
            <Title level={4}>{t("terms.content.ownership.title")}</Title>
            <Paragraph>{t("terms.content.ownership.content")}</Paragraph>
            <Title level={4}>{t("terms.content.prohibited.title")}</Title>
            <Paragraph>{t("terms.content.prohibited.content")}</Paragraph>
            <Paragraph style={{ whiteSpace: "pre-line" }}>
              {t("terms.content.prohibited.list")}
            </Paragraph>
          </div>

          <div>
            <Title level={3}>{t("terms.disclaimer.title")}</Title>
            <Paragraph>{t("terms.disclaimer.content")}</Paragraph>
          </div>

          <div>
            <Title level={3}>{t("terms.limitations.title")}</Title>
            <Paragraph>{t("terms.limitations.content")}</Paragraph>
          </div>

          <div>
            <Title level={3}>{t("terms.accuracy.title")}</Title>
            <Paragraph>{t("terms.accuracy.content")}</Paragraph>
          </div>

          <div>
            <Title level={3}>{t("terms.links.title")}</Title>
            <Paragraph>{t("terms.links.content")}</Paragraph>
          </div>

          <div>
            <Title level={3}>{t("terms.modifications.title")}</Title>
            <Paragraph>{t("terms.modifications.content")}</Paragraph>
          </div>

          <div>
            <Title level={3}>{t("terms.governing.title")}</Title>
            <Paragraph>{t("terms.governing.content")}</Paragraph>
          </div>

          <div>
            <Title level={3}>{t("terms.contact.title")}</Title>
            <Paragraph>{t("terms.contact.content")}</Paragraph>
          </div>

          <Divider />
          <Text type="secondary">{t("terms.last.updated", { date: "2024-03-20" })}</Text>
        </Space>
      </Card>
    </div>
  );
};

export default TermsPage; 